







































































import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import Modifiable from '@/mixins/Modifiable'

const DYNAMIC_MIN_WIDTH = 70

@Component({ name: 'v-input' })
export default class VInput extends Mixins(Modifiable) {
    isHovered: boolean = false

    hasFocus: boolean = false

    stretchWidth: number = 40

    internalValue: string|null = null

    /**
     * Input name (will be obfuscated for username or password)
     */
    @Prop({ type: String, required: true })
    name!: string

    /**
     * Input value
     */
    @Prop({ type: String, default: '' })
    value!: string

    /**
     * Label name
     */
    @Prop({ type: String, default: '' })
    label!: string

    /**
     * Label info tooltip
     */
    @Prop({ type: String, default: '' })
    tooltip!: string

    /**
     * Placeholder text
     */
    @Prop({ type: String, default: '' })
    placeholder!: string

    /**
     * Input field element
     */
    @Prop({ type: String, default: 'text' })
    element!: 'text' | 'textarea'

    /**
     * Error message to display in the label
     */
    @Prop({ type: String })
    error?: string

    /**
     * Max field length
     */
    @Prop({ type: String })
    maxlength?: string

    /**
     * Whether the input is disabled
     */
    @Prop({ type: Boolean, default: false })
    disabled!: boolean

    /**
     * Whether the input should not show extra buttons
     */
    @Prop({ type: Boolean, default: false })
    standalone!: boolean

    /**
     * Whether to autofocus on mount
     */
    @Prop({ type: Boolean, default: false })
    autofocus!: boolean

    /**
     * Whether font should be mono
     */
    @Prop({ type: Boolean, default: true })
    mono!: boolean

    /**
     * Number of buttons to account for
     */
    @Prop({ type: Number, default: 0 })
    buttons!: number

    /**
     * Text size
     */
    @Prop({ type: String, default: 'md' })
    size!: 'md' | 'lg'

    @Prop({ type: Boolean, default: false })
    dynamicWidth!: boolean

    /**
     * Textarea height (lines)
     */
    @Prop({ type: Number, default: 1 })
    height!: number

    mounted(): void {
        setTimeout(() => {
            this.updateValue(this.value)
            if (this.autofocus) {
                this.focus()
            }
        }, 100)
    }

    /**
     * Hacky fix for input fields not updating correctly
     */
    @Watch('value')
    updateValue(value: string) {
        this.update(value)
    }

    /**
     * Obfuscated certain names to trick password managers
     */
    get obfuscatedName(): string {
        if (this.name === 'password') {
            return 'banana'
        }
        if (this.name === 'username') {
            return 'apple'
        }
        return this.name
    }

    /**
     * Component type
     */
    get component(): string {
        return this.element === 'textarea' ? 'textarea' : 'input'
    }

    get modified(): boolean {
        return this.internalValue !== null && this.value !== this.internalValue
    }

    commit(): void {
        this.$nextTick(() => {
            if (this.modified) {
                this.$emit('input', this.internalValue)
            }
            this.blur()
        })
    }

    onFocus(event: FocusEvent): void {
        this.hasFocus = true
        this.$emit('focus', event)
    }

    onMouseOver(event: MouseEvent): void {
        this.isHovered = true
        this.$emit('mouseover', true)
    }

    onMouseOut(event: MouseEvent): void {
        this.isHovered = false
        this.$emit('mouseout', event)
    }

    onKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter' && this.height === 1) {
            this.blur()
        } else if (event.key === 'Escape') {
            this.resetValue()
        }
        this.$emit('keydown', event)
    }

    resetValue(): void {
        this.internalValue = this.value
        this.update(this.value)
        this.blur()
    }

    /**
     * Focus on the input field
     */
    focus(): void {
        (this.$refs.input as HTMLElement).focus()
    }

    /**
     * Unfocus on the input field
     */
    blur(): void {
        this.hasFocus = false;
        (this.$refs.input as HTMLElement).blur()
        this.$emit('blur', event)
    }

    /**
     * Forcefully set the internal value
     *
     * Used as a hacky way for a generated password
     * (or anything else) to be entered here without
     * having to be saved into the store and instantly
     * overwriting the previous value.
     */
    public setInternalValue(value: string): void {
        this.update(value)
    }

    /**
     * Emit update to parent
     */
    update(value: string): void {
        // TODO
        if (this.standalone) {
            this.$emit('input', value)
        }
        // this.$emit('clear-error')
        this.internalValue = value
        this.$emit('internal-input', value)
        if (this.dynamicWidth) {
            this.$nextTick(() => {
                if (this.$refs.sizer) {
                    this.stretchWidth = (this.$refs.sizer as HTMLElement).clientWidth + 24
                    if (this.stretchWidth < DYNAMIC_MIN_WIDTH) {
                        this.stretchWidth = DYNAMIC_MIN_WIDTH
                    }
                }
            })
        }
        // this is bad
        if (this.$refs.input) {
            (this.$refs.input as any).value = value
        }
    }
}
